import React from 'react';
import BreadCrumb from 'Common/BreadCrumb';
import LoanPaymentReportPage from './LoanPaymenReport';

const LoanPaymentReport = () => {
    return (
        <React.Fragment>
            <div className="container-fluid group-data-[content=boxed]:max-w-boxed mx-auto">
                <BreadCrumb title='Pagos de Prestamos' pageTitle='Reportes' />
                <LoanPaymentReportPage />
            </div>
        </React.Fragment>
    )
}

export default LoanPaymentReport;